import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Role } from '../../types';

/**
 * Garde pour les routes admin sur mobile : seul un utilisateur avec le rôle admin peut accéder.
 * Un client authentifié est redirigé vers /mobile/dashboard.
 */
export const MobileAdminGuard: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gray-100 dark:bg-gray-950">
        <div className="w-10 h-10 border-2 border-primary-500 dark:border-primary-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== Role.ADMIN) return <Navigate to="/mobile/dashboard" replace />;

  return <Outlet />;
};
